import React, { useState } from "react";
import { Button } from "controls";
import { action, API, controller } from "api";
import { ToFormData } from "hooks";
import InputTags from "../Form/QuickAdding/InputTags";
import { toast } from "react-toastify";

const UpdateTag = ({ selectedRec, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({ prodTags: [] });

  const handleInpChg = (e) => {
    setValues((j) => ({
      ...j,
      prodTags: [...e.target.value],
    }));
  };

  const handleSubmit = () => {
    setLoading(true);
    API(controller.Product + action.UpdateBCST).post(
      ToFormData({
        all: selectedRec?.all,
        ids: selectedRec?.items,
        type: "tag",
        prodTags: values.prodTags.map((j) => ({ tagId: j })),
      }),
      (res) => {
        toast.success(
          "You have successfully updated all of the selected product tags"
        );
        setLoading(false);
        handleClose();
      }
    );
  };

  return (
    <div className="pt-4 flex flex-col gap-5">
      <InputTags {...{ handleInpChg, values, setValues }} size="large" />

      <div className="flex justify-end gap-2">
        <Button
          onClick={handleClose}
          variant="text"
          size="large"
          className="!min-w-[130px]"
        >
          Don't Update
        </Button>
        <Button size="large" loading={loading} onClick={handleSubmit}>
          Update Tags
        </Button>
      </div>
    </div>
  );
};

export default UpdateTag;
